<div class="flex flex-col gap-2 mt-4 p-4 bg-third-level rounded-lg" *transloco="let t">
  <div class="flex items-center gap-2">
    <i class="ph ph-star text-green-400 text-lg"></i>
    <span class="text-sm text-gray-300">
      {{ t('project.steps.rfd.useCase.score.strength') }}
    </span>
  </div>
  <div class="flex items-center gap-2">
    <i class="ph ph-sigma text-gray-300 text-lg"></i>
    <span class="text-sm text-gray-300">
      {{ t('project.steps.rfd.useCase.score.attributesScored') }}
    </span>
  </div>
</div>
